import { isMainThread } from 'node:worker_threads';
import {
  readFileBrowserActivityFromShared,
  syncFileBrowserActivityToShared,
} from './activity-shared.js';
import type { FileBrowserActivitySnapshot } from './activity-types.js';
import { snapshotFromMain, setWorkerMirror } from './counts.js';

let activityPublisher: ((snapshot: FileBrowserActivitySnapshot) => void) | null = null;

export function registerFileBrowserActivityPublisher(
  publisher: (snapshot: FileBrowserActivitySnapshot) => void,
): void {
  activityPublisher = publisher;
}

export function applyFileBrowserActivityFromMain(snapshot: FileBrowserActivitySnapshot): void {
  setWorkerMirror(snapshot);
}

export function syncMainActivityToShared(): void {
  syncFileBrowserActivityToShared(snapshotFromMain());
}

export function currentFileBrowserActivity(): FileBrowserActivitySnapshot {
  if (isMainThread) return snapshotFromMain();
  return readFileBrowserActivityFromShared();
}

function publishActivityToWorker(): void {
  if (!isMainThread) return;
  activityPublisher?.(snapshotFromMain());
}

/** Sync current browse/read activity to the symbol index worker (after DB init). */
export function publishFileBrowserActivityToWorker(): void {
  publishActivityToWorker();
}

export function getFileBrowserActivitySnapshot(): FileBrowserActivitySnapshot {
  return snapshotFromMain();
}

export function publishAfterActivityChange(): void {
  syncMainActivityToShared();
  publishActivityToWorker();
}
